import { render } from "./portfolioSegment.vue?vue&type=template&id=0db4abf0"
import script from "./portfolioSegment.vue?vue&type=script&lang=js"
export * from "./portfolioSegment.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__